// extracted by mini-css-extract-plugin
export default {"heading":"Wp-z","createAccount":"Xp-z","disabled":"Yp-z","copy":"Zp-z","terms":"_p-z"};